<template>
  <div class="product-main-body -img-type">
    <div class="product-main-body__wrapper">
      <div class="product-main-body__lists-wrapper" v-if="lists.length > 0">
        <div
          class="list__item"
          v-for="product in products"
          :key="product.id"
          :class="[
            product.cover_position,
            product.covers && product.covers.length > 1 ? 'double' : '',
            Number(product.type_id) === 6 ? 'is-type-of-product' : ''
          ]"
          :data-title="product.name.en"
          :data-bg="product.bg"
          :data-pos="product.cover_position"
          :data-id="product.id"
          ref="items"
        >
          <div @click="onJump(product)">
            <transition @after-enter="onAfterAfter" @leave="onLeave">
              <div
                class="product-main-body__fixted-title"
                ref="fixedTitle"
                :class="[product.cover_position]"
                v-if="currentView && Number(currentView.id) === Number(product.id)"
                :style="{
                  top: $bowser.mobile ? `${mobileFixTitleTop}px` : ''
                }"
              >
                <p>{{ product.name.en }}</p>
              </div>
            </transition>
            <div class="scrollObj">
              <div class="item__cover">
                <template v-if="$bowser.mobile">
                  <template v-if="Number(product.type_id) === 6">
                    <div class="cover__img-box">
                      <img :src="product.inner_big_show.mobile" alt="" class="mobileFull" />
                    </div>
                  </template>
                  <template v-else>
                    <div
                      class="cover__img-box xxx"
                      v-for="(img, index) in product.covers"
                      :key="index"
                    >
                      <img
                        :src="img"
                        alt=""
                        @load="onImgLoaded"
                        :class="{
                          mobileFull: product.covers.length === 1
                        }"
                      />
                    </div>
                  </template>
                </template>
                <template v-else>
                  <div class="cover__img-box" v-for="(img, index) in product.covers" :key="index">
                    <img :src="img" alt="" class="repain" @load="onImgLoaded" />
                  </div>
                </template>
              </div>
              <div class="item__info">
                <p>{{ product.name.cn }} | {{ product.year }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let beforeScrollTop = 0;
export default {
  name: 'product-list-type-img',
  props: {
    lists: {
      type: Array,
      default: null,
    },
  },
  data() {
    const that = this;
    return {
      products: that.lists,
      currentView: null,
      currentBg: '',
      innerWidth: window.innerWidth,
      pxRatio: window.devicePixelRatio,
      mobileFixTitleTop: 0,
    };
  },
  watch: {
    lists: {
      handler(val) {
        const that = this;
        this.products = val;
        that.$nextTick(() => {
          that.currentView = that.products['0'];
        });
      },
      immediate: true,
    },
    currentBg(val) {
      this.$root.$emit('bgChanged', val);
    },
  },
  computed: {
    compareOffsetTop() {
      return this.$bowser.mobile
        ? this.mobileFixTitleTop
        : this.$refs.fixedTitle['0'].getBoundingClientRect().top;
    },
    currentFixedTitle() {
      return this.currentView ? this.currentView.name.en : '';
    },
    currentFixedType() {
      return this.currentView ? this.currentView.type : '';
    },
    limit: {
      get() {
        const obj = this.$refs.items['1'];
        if (obj) {
          return parseInt(window.getComputedStyle(obj, null).marginTop, 10);
        }
        return 0;
      },
      set(val) {
        return val;
      },
    },
  },
  mounted() {
    const that = this;
    that.currentView = that.products['0'];
    that.currentBg = that.currentView.bg;
    that.$nextTick(() => {
      window.addEventListener('scroll', that.onScroll);
      if (that.$bowser.mobile) {
        window.addEventListener('resize', that.onResize);
      }
    });
    that.$parent.$on('afterBackTop', () => {
      that.currentView = that.products['0'];
      that.currentBg = that.currentView.bg;
    });
    if (that.$bowser.mobile) {
      const mb = document.querySelector('.product-main-body');
      const s = window.getComputedStyle(mb, null);
      const sMarginTop = parseInt(s.marginTop, 10);
      const w = document.querySelector('.product-main-body__lists-wrapper');
      const wTop = w.getBoundingClientRect().top;
      that.mobileFixTitleTop = wTop - sMarginTop / 2;
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      const obj = this.$refs.items['1'];
      const offset = obj ? parseInt(window.getComputedStyle(obj, null).marginTop, 10) : 0;
      console.log(offset);
      this.limit = offset;
    },
    onScroll() {
      const that = this;
      const { limit } = that;
      // const currentIndex = -1;
      const screenScrollTop = document.body.getBoundingClientRect().top;
      const isLastP = false;
      const delta = beforeScrollTop - screenScrollTop;
      beforeScrollTop = screenScrollTop;
      const currentView = that.$refs.items.find((item) => {
        const bcr = item.getBoundingClientRect();

        const isInView = delta >= 0
          ? bcr.top < that.compareOffsetTop + limit && bcr.bottom > that.compareOffsetTop + limit
          : bcr.top < that.compareOffsetTop - limit && bcr.bottom > that.compareOffsetTop;
        // currentIndex = isInView ? index : currentIndex;
        // isLastP = currentIndex === that.$refs.items.length - 1;
        // if (isLastP) {
        //   console.log(bcr.bottom, that.$screenHeight);
        //   const mobileBottomLimit = that.$bowser.mobile ? limit * 4 : 0;
        //   isInView = bcr.top < that.compareOffsetTop + limit
        //     && bcr.top + bcr.height > that.$screenHeight - mobileBottomLimit;
        // }
        return isInView;
      });

      if (currentView) {
        that.currentView = this.products.find((item) => item.id === Number(currentView.dataset.id));
        that.currentBg = that.currentView.bg;
      } else if (isLastP) {
        that.currentView = null;
      }
    },
    onAfterAfter(el) {
      el.classList.add('show');
    },
    onLeave(el, done) {
      el.classList.add('hidden');
      setTimeout(() => {
        done();
      }, 800);
    },
    onJump(item) {
      if (Number(item.type_id) === 6) {
        window.location.href = item.link;
      } else {
        this.$router.push({
          path: `/product/${encodeURIComponent(item.name.en)}/${item.id}`,
        });
      }
    },
    onImgLoaded(e) {
      const obj = e.currentTarget;
      obj.dataset.naturalWidth = obj.naturalWidth;
      if (this.$bowser.mobile) {
        obj.style.cssText = `width: ${Math.floor((obj.naturalWidth / 750 / 2.19) * 100)}vw;`;
      }
      this.$root.$emit('resize', obj);
    },
  },
};
</script>

<style></style>
